import directus from '@/plugins/directusSdk'
import errorDirectus from '@/lib/Error/directus'

export default {
  async setDefaultAvatar ({ dispatch }) {
    try {
      const files = await directus.getFiles({
        fields: [ 'id' ],
        filter: {
          'metadata': {
            contains: 'no_image'
          }
        }
      })

      const users = await directus.getUsers({
        fields: [ 'id' ]
      })

      for (let user of users.data) {
        await directus.updateUser(user.id, {
          avatar: files.data[0].id
        })
      }

      return true
    } catch (err) {
      errorDirectus(err, dispatch)
      return false
    }
  }
}
